import { Box, HStack, Text, useTheme } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export default function ExamProgressLegend() {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <HStack mt={16} spacing={4}>
      {[
        ["white", "gray.300", t("learning_path_progresses_page.todo")],
        [
          "white",
          theme.colors.primary.DEFAULT,
          t("learning_path_progresses_page.started"),
        ],
        [
          `linear-gradient(white 50%, ${theme.colors.primary[200]} 50% )`,
          theme.colors.primary.DEFAULT,
          t("learning_path_progresses_page.done"),
        ],
        [
          theme.colors.green[100],
          theme.colors.green[500],
          t("learning_path_progresses_page.approved"),
        ],
        [
          theme.colors.red[500],
          theme.colors.red[200],
          t("learning_path_progresses_page.rejected"),
        ],
      ].map(([bg, borderColor, description], index) => (
        <HStack key={index}>
          <Text>{description}</Text>
          <Box
            aspectRatio={1}
            width={7}
            display="flex"
            justifyContent="center"
            alignItems="center"
            bg={bg}
            borderColor={borderColor}
            borderWidth={2}
            borderRadius={100}
          />
        </HStack>
      ))}
    </HStack>
  );
}
